import React, { useState } from 'react';
import translations from '../../utils/language/translations.json';
import { useTranslation } from 'react-i18next';
import RadioButtonSlider from '../UsefulComponent/RadioButtonSlider';
import { useNavigate } from "react-router-dom";
import PaginationComponentFeedback from './PaginationComponentFeedback';

const FeedbackBoard = ({ userFeedback }) => {
    const { t: translate, i18n } = useTranslation(); 
    const currentLang = i18n.language; 
    const t = (key) => translations.Feedback[key][currentLang];

    const navigate = useNavigate();
    const totalFeedbackCount = userFeedback['Seller'].length + userFeedback['Buyer'].length;

    const [feedbackType, setFeedbackType] = useState('Seller');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);

    const feedbackData = userFeedback[feedbackType];
    const totalPages = Math.ceil(feedbackData.length / itemsPerPage);
    const currentFeedbackData = feedbackData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    return (
        <div className="feedback-container">
            <div className="feedback-header-section">
                <div className='form-group'>
                <h2 className="feedback-title">{t('All feedback')} ({totalFeedbackCount})</h2>
                <div className='marginCenter'><RadioButtonSlider activeType={feedbackType} setActiveType={setFeedbackType} leftLabel={'Seller'} rightLabel={'Buyer'} t={t} /></div>
           </div> </div>

            <div className="feedback-list">
                {currentFeedbackData.map((item, index) => (
                    <div key={index} className="feedback-item">
                        <div className="feedback-user-info">
                            <span 
                                className="feedback-username" 
                                onClick={() => navigate(`/ViewUserProfil/${item.ShowName}`)}
                            >
                                {item.ShowName}
                            </span>
                            <span className="feedback-rating">
                                ({item.NumberOfTransactions}){item.Rating * 20}%
                            </span>
                        </div>
                        <span className="feedback-time">
                            {new Date(item.FeedbackDate).toLocaleDateString()}
                        </span>
                        <p className="feedback-comment">{item.Comment}</p>
                    </div>
                ))}
            </div>
{currentFeedbackData.length > 0 &&
            <PaginationComponentFeedback
                totalPages={totalPages}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
                partialOnly={false} 
            />}
        </div>
    );
};

export default FeedbackBoard;
